/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface WellpassBenefitDetailsDTO
 */
export interface WellpassBenefitDetailsDTO {
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'benefit': WellpassBenefitDetailsDTOBenefitEnum;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'status': WellpassBenefitDetailsDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'nonCashBenefitUsageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'deadlineDate': string;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'nextStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WellpassBenefitDetailsDTO
     */
    'nextEndDate': string;
    /**
     * 
     * @type {number}
     * @memberof WellpassBenefitDetailsDTO
     */
    'monthlyBudget': number;
    /**
     * 
     * @type {number}
     * @memberof WellpassBenefitDetailsDTO
     */
    'maximumBenefitBudget': number;
}

export const WellpassBenefitDetailsDTOBenefitEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type WellpassBenefitDetailsDTOBenefitEnum = typeof WellpassBenefitDetailsDTOBenefitEnum[keyof typeof WellpassBenefitDetailsDTOBenefitEnum];
export const WellpassBenefitDetailsDTOStatusEnum = {
    Inactive: 'INACTIVE',
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Expiring: 'EXPIRING',
    TooLate: 'TOO_LATE',
    Whitelist: 'WHITELIST',
    MembershipPending: 'MEMBERSHIP_PENDING'
} as const;

export type WellpassBenefitDetailsDTOStatusEnum = typeof WellpassBenefitDetailsDTOStatusEnum[keyof typeof WellpassBenefitDetailsDTOStatusEnum];


